import { render, staticRenderFns } from "./DashboardListsFilters.vue?vue&type=template&id=0edc6233&"
import script from "./DashboardListsFilters.vue?vue&type=script&lang=js&"
export * from "./DashboardListsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports